<template>
    <div class="main-content md-layout assortment" data-app>
        <!-- Novo Filtro -->
        <div class="header-search">
            <md-card class="pl-1 pr-1 search__card bt-blue500 hidden-card">
                <maximize-and-minimize></maximize-and-minimize>
                <md-card-header class="pb-0">
                    <div class="header__filter">
                        <div style="cursor: not-allowed;">
                            <md-icon>search</md-icon>
                        </div>
                        <span class="filter__aply">
                            {{ selectedHistoryFilterName }}
                        </span>
                    </div>
                </md-card-header>
                <md-card-content class="pt-2 pb-2">
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 mb-2">
                            <md-field>
                                <label for="history">Histórico</label>
                                <md-menu
                                    class="md-layout md-size-50"
                                    md-align-trigger
                                    md-size="big"
                                    :mdCloseOnClick="false"
                                    :mdCloseOnSelect="true"
                                >
                                    <md-input
                                        md-menu-trigger
                                        v-model="selectedHistoryFilterName"
                                        style="cursor: pointer"
                                        readonly
                                    ></md-input>
                                    <md-icon>keyboard_arrow_down</md-icon>

                                    <md-menu-content
                                        class="md-layout-item md-size-80"
                                        style="background: #fff"
                                    >
                                        <div
                                            style="text-decoration: underline"
                                            class="mb-1"
                                        >
                                            <b>Favoritos</b>
                                        </div>
                                        <div
                                            class="md-layout"
                                            v-for="(filter, idx) in filterLiked"
                                            :key="`filter-favorite--${idx}`"
                                        >
                                            <div class="">
                                                <button
                                                    class="btn-star"
                                                    @click="unlike(filter.id)"
                                                >
                                                    <i
                                                        class="fas fa-star"
                                                        style="
                                                            color: #000;
                                                            -webkit-text-stroke-width: 1px;
                                                            -webkit-text-stroke-color: #000;
                                                        "
                                                    ></i>
                                                </button>
                                            </div>
                                            <div
                                                class="
                                                    md-layout-item md-size-50
                                                "
                                            >
                                                <md-menu-item
                                                    class=""
                                                    @click="
                                                        selectHistoryFilter(
                                                            filter
                                                        )
                                                    "
                                                >
                                                    {{ filter.name }}
                                                </md-menu-item>
                                            </div>
                                        </div>
                                        <div
                                            style="text-decoration: underline"
                                            class="mb-1"
                                        >
                                            <b>Recentes</b>
                                        </div>
                                        <div
                                            class="md-layout"
                                            v-for="(filter,
                                            idx) in filterUnLiked"
                                            :key="`filter-recente--${idx}`"
                                        >
                                            <div class="" v-if="filter.id">
                                                <button
                                                    class="btn-star"
                                                    @click="like(filter.id)"
                                                >
                                                    <i
                                                        class="fas fa-star"
                                                        style="
                                                            color: #fff;
                                                            -webkit-text-stroke-width: 1px;
                                                            -webkit-text-stroke-color: #000;
                                                        "
                                                    ></i>
                                                </button>
                                            </div>
                                            <div
                                                class="
                                                    md-layout-item md-size-50
                                                "
                                            >
                                                <md-menu-item
                                                    class=""
                                                    @click="
                                                        selectHistoryFilter(
                                                            filter
                                                        )
                                                    "
                                                >
                                                    {{ filter.name }}
                                                </md-menu-item>
                                            </div>
                                        </div>
                                    </md-menu-content>
                                </md-menu>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-30 md-small-size-100"
                            @click="treeModalOpen(true)"
                        >
                            <md-field>
                                <label style="cursor: pointer">
                                    Árvore de sortimento
                                </label>
                                <md-input
                                    name="node"
                                    value=""
                                    style="cursor: pointer"
                                    v-model="selectedHistoryFilterNodeName"
                                    readonly
                                >
                                </md-input>
                                <md-icon style="cursor: pointer">
                                    account_tree
                                </md-icon>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-70 md-small-size-100"
                        >
                            <md-field
                                title="Insira o ID dos CDs (separados por vírgula)"
                            >
                                <label
                                    style="top: -0.8rem; font-size: 0.6875rem"
                                >
                                    CD(s)
                                </label>
                                <multiselect
                                    name="dcs"
                                    v-model="selectedHistoryFilterDcs"
                                    :custom-label="getDcName"
                                    :options="dcsData"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    label="name"
                                    track-by="external_id"
                                    placeholder="Selecione"
                                ></multiselect>
                            </md-field>
                        </div>

                        <div
                            class="md-layout-item md-size-15 md-small-size-100"
                        >
                            <md-field>
                                <label>Preço de</label>
                                <md-input
                                    type="number"
                                    v-model="selectedHistoryFilterMinPrice"
                                ></md-input>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-15 md-small-size-100"
                        >
                            <md-field>
                                <label>Preço até</label>
                                <md-input
                                    type="number"
                                    v-model="selectedHistoryFilterMaxPrice"
                                ></md-input>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-40 md-small-size-100"
                        >
                            <md-autocomplete
                                v-model="brandTermSearch"
                                :md-options="_brands"
                                @md-changed="handleInputSearch"
                                @md-selected="selectBrand"
                            >
                                <label>Marca</label>

                                <template
                                    slot="md-autocomplete-item"
                                    slot-scope="{ item }"
                                >
                                    {{ item.name }}
                                </template>
                            </md-autocomplete>
                        </div>
                        <div
                            class="md-layout-item md-size-30 md-small-size-100"
                        >
                            <md-switch
                                :model="newItems.isChecked"
                                @change="filterNewItems"
                            >
                                {{ newItems.field }}
                            </md-switch>
                            <hr />
                        </div>

                        <div class="md-layout-item md-size-100 text-right mt-1">
                            <span
                                style="
                                    color: #666;
                                    padding: 10px;
                                    vertical-align: middle;
                                    line-height: 35px;
                                "
                            >
                                <span v-if="filterDirty">
                                    As alterações não foram salvas.
                                </span>
                                <span v-if="priceError">
                                    Erro: O preço mínimo não pode ser maior que
                                    o máximo.
                                </span>
                            </span>

                            <md-button
                                class="md-danger mt-0  md-size-100 mr-1"
                                @click="clearFilter()"
                            >
                                Limpar
                            </md-button>

                            <md-button
                                class="md-primary mt-0  md-size-100"
                                @click="applyFilter()"
                                :disabled="!!anyFilterError"
                            >
                                Pesquisar
                            </md-button>
                        </div>
                    </div>
                </md-card-content>
            </md-card>
        </div>

        <!-- TABELA -->
        <div class="md-layout-item md-size-100" style="z-index: 0">
            <md-card class="pl-1 pr-1 bt-blue500">
                <md-card-header>
                    <h4 class="title pt-1">Sortimento</h4>
                </md-card-header>
                <md-card-content>
                    <div
                        class="md-content md-table table-striped"
                        v-if="!curvesLoading"
                    >
                        <div class="md-content md-table-content">
                            <table id="assortmentTable">
                                <thead>
                                    <tr>
                                        <th colspan="7">Itens</th>
                                        <th colspan="8">Estoque</th>
                                    </tr>
                                    <tr>
                                        <th
                                            v-for="(column,
                                            index) in tableColumnVisible"
                                            v-bind:key="`columnh-${index}`"
                                            class="md-table-head"
                                            :class="
                                                'assortment-' +
                                                    assortmentClasses[index]
                                            "
                                        >
                                            <div
                                                class="md-table-head-container"
                                            >
                                                <div
                                                    class="md-table-head-label"
                                                >
                                                    <md-tooltip
                                                        md-direction="top"
                                                        >{{ column.tooltip }}
                                                    </md-tooltip>
                                                    {{ column.name }}
                                                </div>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="text-right">
                                    <tr
                                        class="md-table-row no-hover"
                                        v-for="(item, index) in curvesData"
                                        v-bind:key="`row-${index}`"
                                    >
                                        <td
                                            class="md-table-cell"
                                            v-for="(column,
                                            index) in objectKeys(
                                                tableColumnVisible
                                            )"
                                            :key="`columnb-${index}`"
                                            :class="[
                                                insertBgColor(item, column)
                                                    ? 'total' +
                                                      '-' +
                                                      column.split('_')[0]
                                                    : '',
                                                matchReference(item, column)
                                                    ? ''
                                                    : 'out-of-reference color-focus',
                                                assortmentColumnClickable[
                                                    column
                                                ]
                                                    ? 'cell-drill-down'
                                                    : ''
                                            ]"
                                            :title="
                                                (column + '_meta' in item
                                                    ? 'Meta: ' +
                                                      item[column + '_meta'] +
                                                      ' | '
                                                    : '') +
                                                    'Valor: ' +
                                                    formatNumber(
                                                        item[column],
                                                        assortmentTypes[column]
                                                    )
                                            "
                                            @click="
                                                assortmentColumnClickable[
                                                    column
                                                ]
                                                    ? preDetailModalOpen(
                                                          item,
                                                          column
                                                      )
                                                    : null
                                            "
                                        >
                                            <div
                                                class="md-table-cell-container"
                                                v-if="
                                                    (column === 'items_new') &
                                                        (item[column] === 0 ||
                                                            item[column] ===
                                                                '0')
                                                "
                                                style="font-weight: bold"
                                            >
                                                -
                                            </div>
                                            <div
                                                class="md-table-cell-container"
                                                v-else
                                            >
                                                {{
                                                    formatNumber(
                                                        item[column],
                                                        assortmentTypes[column],
                                                        true
                                                    )
                                                }}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="text-center mt--2 pb-2" v-else>
                        <img
                            src="loader.svg"
                            style="width: 100px; height: 100px"
                        />
                    </div>
                </md-card-content>
            </md-card>
        </div>

        <!-- VU Meter -->
        <div class="md-layout-item md-size-100 vumeter-remove-border">
            <div class="md-layout md-alignment-top-center">
                <div
                    class="
                        md-layout-item md-size-20 md-small-size-100
                        p-2
                        change-auto-padding
                    "
                    v-for="(vuMeterDefinition, index) in vuMeterDefinitions"
                    :key="vuMeterDefinition.curve"
                >
                    <md-card>
                        <keep-alive>
                            <component
                                :is="vuMeterChart"
                                :value="
                                    curveDataVUMeter
                                        ? curveDataVUMeter[index]
                                        : 0
                                "
                                :definitions="vuMeterDefinition"
                                :onClick="vuMeterOnClick"
                            ></component>
                        </keep-alive>
                    </md-card>
                </div>
            </div>
        </div>

        <!-- Stock chart -->
        <div class="md-layout-item md-size-50 md-small-size-100">
            <md-card class="p-1 topper-chart">
                <keep-alive>
                    <component
                        :is="stockChart"
                        :data="curvesDataStock"
                        :loading="curvesLoading"
                        :onClick="stockChartOnClick"
                    ></component>
                </keep-alive>
            </md-card>
        </div>

        <!-- DependencyWheel Diagram -->
        <div class="md-layout-item md-size-50 md-small-size-100">
            <md-card class="pl-1 pr-1 pb-1 topper-chart">
                <div>
                    <md-checkbox
                        v-for="(item, index) in checkboxDependencyWheelChart"
                        :key="item.curve"
                        :model="item.isChecked"
                        @change="
                            checkboxIsSelected(
                                'checkboxDependencyWheelChart',
                                index
                            )
                        "
                        >{{ item.curve }}
                    </md-checkbox>
                </div>
                <keep-alive>
                    <component
                        :is="dependencyWheelChart"
                        :data="curvesDataDependencyWheel"
                        :names="dependencyWheelNames"
                        :loading="curvesLoading"
                        :onNodeClick="dependencyWheelChartOnNodeClick"
                        :onPointClick="dependencyWheelChartOnPointClick"
                    ></component>
                </keep-alive>
            </md-card>
        </div>

        <!-- Histogram Stock Money Tc -->
        <div class="md-layout-item md-size-50 md-small-size-100">
            <md-card class="p-1">
                <div>
                    <md-checkbox
                        v-for="(item, index) in stockMoneyCoverageRanges"
                        :key="item.track"
                        :model="item.isChecked"
                        @change="
                            checkboxIsSelected(
                                'stockMoneyCoverageRanges',
                                index
                            )
                        "
                    >
                        {{ item.track }}
                    </md-checkbox>
                </div>
                <keep-alive>
                    <component
                        :is="histogramStockCurves"
                        :data="
                            handlerAssortmentDataChartToStock(
                                'stockMoneyCoverageRanges',
                                'tc_tracks',
                                'tc_track'
                            )
                        "
                        :tracks="stockMoneyCoverageRanges"
                        :loading="curvesLoading"
                        :onClick="stockCoveragesChartOnPointClick"
                        :title="'Estoque Por Faixa de Tempo de Cobertura (R$)'"
                        :prefix="'R$'"
                        :keys="{
                            objectKey: 'tc_tracks',
                            valueKey: 'stock_cost'
                        }"
                    ></component>
                </keep-alive>
            </md-card>
        </div>

        <!-- Histogram Stock Cubage Tc -->
        <div class="md-layout-item md-size-50 md-small-size-100">
            <md-card class="p-1">
                <div>
                    <md-checkbox
                        v-for="(item, index) in stockCubageCoverageRanges"
                        :key="item.track"
                        :model="item.isChecked"
                        @change="
                            checkboxIsSelected(
                                'stockCubageCoverageRanges',
                                index
                            )
                        "
                    >
                        {{ item.track }}
                    </md-checkbox>
                </div>
                <keep-alive>
                    <component
                        :is="histogramStockCurves"
                        :data="
                            handlerAssortmentDataChartToStock(
                                'stockCubageCoverageRanges',
                                'tc_tracks',
                                'tc_track'
                            )
                        "
                        :tracks="stockCubageCoverageRanges"
                        :loading="curvesLoading"
                        :onClick="stockCoveragesChartOnPointClick"
                        :title="
                            'Estoque Por Faixa de Tempo de Cobertura (Cubagem)'
                        "
                        :keys="{
                            objectKey: 'tc_tracks',
                            valueKey: 'stock_cubage'
                        }"
                    ></component>
                </keep-alive>
            </md-card>
        </div>

        <!-- Histogram Stock Money Last Entry -->
        <div class="md-layout-item md-size-50 md-small-size-100">
            <md-card class="p-1">
                <div>
                    <md-checkbox
                        v-for="(item, index) in stockMoneyLastEntryRanges"
                        :key="item.track"
                        :model="item.isChecked"
                        @change="
                            checkboxIsSelected(
                                'stockMoneyLastEntryRanges',
                                index
                            )
                        "
                    >
                        {{ item.track }}
                    </md-checkbox>
                </div>
                <keep-alive>
                    <component
                        :is="histogramStockCurves"
                        :data="
                            handlerAssortmentDataChartToStock(
                                'stockMoneyLastEntryRanges',
                                'last_entry_tracks',
                                'last_entry_track'
                            )
                        "
                        :tracks="stockMoneyLastEntryRanges"
                        :loading="curvesLoading"
                        :onClick="stockEntriesChartOnPointClick"
                        :title="'Estoque Por Faixa da Última Entrada (R$)'"
                        :prefix="'R$'"
                        :keys="{
                            objectKey: 'last_entry_tracks',
                            valueKey: 'stock_cost'
                        }"
                    ></component>
                </keep-alive>
            </md-card>
        </div>

        <!-- Histogram Stock Cubage Last Entry -->
        <div class="md-layout-item md-size-50 md-small-size-100">
            <md-card class="p-1">
                <div>
                    <md-checkbox
                        v-for="(item, index) in stockCubageLastEntryRanges"
                        :key="item.track"
                        :model="item.isChecked"
                        @change="
                            checkboxIsSelected(
                                'stockCubageLastEntryRanges',
                                index
                            )
                        "
                    >
                        {{ item.track }}
                    </md-checkbox>
                </div>
                <keep-alive>
                    <component
                        :is="histogramStockCurves"
                        :data="
                            handlerAssortmentDataChartToStock(
                                'stockCubageLastEntryRanges',
                                'last_entry_tracks',
                                'last_entry_track'
                            )
                        "
                        :tracks="stockCubageLastEntryRanges"
                        :loading="curvesLoading"
                        :onClick="stockEntriesChartOnPointClick"
                        :title="'Estoque Por Faixa da Última Entrada (Cubagem)'"
                        :keys="{
                            objectKey: 'last_entry_tracks',
                            valueKey: 'stock_cubage'
                        }"
                    ></component>
                </keep-alive>
            </md-card>
        </div>

        <!-- Tree Map Charts -->
        <div class="main-content md-layout cubage_chart">
            <div style="display:flex;width:100%; margin-left:30px;">
                <!-- <md-switch
                    :model="checkBoxMiniDC.isChecked"
                    :key="checkBoxMiniDC.isChecked"
                    @change="filterMiniDC()"
                >
                    {{ checkBoxMiniDC.field }}
                </md-switch> -->

                <div style="display: inline-block;" v-if="curvesMiniDCLoading">
                    <img src="loader.svg" style="width: 40px;height: 40px;" />
                </div>
            </div>
            <!-- Tree Map chart Money -->
            <div class="md-layout-item md-size-50 md-small-size-100">
                <md-card class="p-1" id="tree_chart_id">
                    <keep-alive>
                        <component
                            :is="treeMapCurvesCubageMoney"
                            :data="curvesHistogramTreeMapMoneyDataFilter"
                            :loading="curvesLoading"
                            :onHandle="handleCharts"
                            :onPointClick="treeMapChartOnPointClick"
                        ></component>
                    </keep-alive>
                </md-card>
            </div>

            <!-- Tree Map chart Cubage -->
            <div class="md-layout-item md-size-50 md-small-size-100">
                <md-card class="p-1" id="tree_chart_id">
                    <keep-alive>
                        <component
                            :is="treeMapCurvesCubage"
                            :data="curvesHistogramTreeMapDataFilter"
                            :loading="curvesLoading"
                            :onHandle="handleCharts"
                            :onPointClick="treeMapChartOnPointClick"
                        ></component>
                    </keep-alive>
                </md-card>
            </div>

            <!-- Histogram Curves chart -->
            <div class="md-layout-item md-size-100 md-small-size-100">
                <md-card class="p-1 topper-chart" id="cubage_chart_id">
                    <div class="md-layout">
                        <md-switch
                            :key="checkboxCubageChartMiniDC.field"
                            :model="checkboxCubageChartMiniDC.isChecked"
                            @change="checkboxCubageChartMiniDCToggle()"
                            >{{ checkboxCubageChartMiniDC.field }}
                        </md-switch>
                        <md-switch
                            :key="filterDCCubage.field"
                            :model="filterDCCubage.isChecked"
                            @change="getDCsInCubage()"
                            >{{ filterDCCubage.field }}
                        </md-switch>
                    </div>
                    <keep-alive>
                        <component
                            :is="histogramCurves"
                            :data="curvesHistogramDataFilter"
                            :loading="curvesHistogramLoading"
                            :value="curvesHistogramDataFilter"
                            :onPointClick="histogramChartOnPointClick"
                        ></component>
                    </keep-alive>
                </md-card>
            </div>
        </div>

        <!-- Modal to ask filter name when saving -->
        <modal v-if="filterModal" @close="filterModalOpen(false)">
            <template slot="header">
                <h4 class="modal-title">Salvar filtro</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="filterModalOpen(false)"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>

            <template slot="body">
                <div class="md-layout">
                    <div class="md-layout-item md-small-size-100 md-size-100">
                        <md-field>
                            <label>Nome do filtro</label>
                            <md-input v-model="filter.name"></md-input>
                        </md-field>
                    </div>
                </div>
            </template>

            <template slot="footer">
                <md-button class="md-simple" @click="filterModalOpen(false)">
                    Cancelar
                </md-button>
                <md-button
                    class="md-primary"
                    @click="filterModalSubmit()"
                    :disabled="!filter.name"
                >
                    Salvar
                </md-button>
            </template>
        </modal>

        <!-- Modal to select tree node -->
        <VuetifyModal
            v-if="treeModal"
            v-model="treeModal"
            @close="treeModalOpen(false)"
            width="width"
        >
            <template slot="header">
                <h4 class="modal-title">Item da árvore de sortimento</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="treeModalOpen(false)"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>

            <template slot="body">
                <v-draggable-treeview
                    v-model="treeData"
                    :editable="false"
                    :openCallback="readTreeChild"
                    :clickCallback="selectTreeChild"
                ></v-draggable-treeview>
            </template>

            <template slot="footer"></template>
        </VuetifyModal>

        <!-- Modal to detail curve items -->
        <VuetifyModal
            v-if="detailModal"
            v-model="detailModal"
            @close="detailModalOpen(false)"
            width="1100"
            id="detail-modal"
        >
            <template slot="header">
                <h4 class="modal-title adjust-modal-title-text">
                    {{ detailModalHeaderTitle }}
                </h4>

                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="detailModalOpen(false), clearInputsFilter()"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>

            <template #body>
                <v-card v-if="!curveDetailsLoading">
                    <v-card-title>
                        <md-button
                            class="md-just-icon md-simple"
                            @click.native="handleDownload()"
                        >
                            <img
                                src="@/assets/icons/excel.svg"
                                class="icon"
                                title="Exportar Dados"
                            />
                        </md-button>
                        <span style="font-size: .8rem">
                            Exportar Dados
                        </span>
                        <v-btn
                            style="border-color: #0d47a1; color: #0d47a1; margin-left: 4px"
                            outlined
                            @click="clearInputsFilter"
                        >
                            Limpar Filtros
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Pesquisa Inteligente"
                            clearable
                        ></v-text-field>
                    </v-card-title>

                    <v-data-table
                        :footer-props="{
                            'items-per-page-text': 'Itens por Pagina '
                        }"
                        :items-per-page="20"
                        :headers="headers"
                        :items="modalDataVue()"
                        :header-props="{ sortByText: 'Ordernar Por: ' }"
                        :hide-default-footer="true"
                        density="compact"
                        item-key="external_id"
                    >
                        <template v-slot:header.="{ header }">
                            {{ header }}
                        </template>
                        <!--Pesquisa pelo código external_id-->
                        <template v-slot:header.external_id="{ header }">
                            {{ header.text }}

                            <v-menu offset-y :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon
                                            small
                                            :style="{
                                                color: table.external_id
                                                    ? 'var(--green-500)'
                                                    : ''
                                            }"
                                        >
                                            mdi-filter
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <div
                                    style="background-color: white; width: 280px; padding: 10px"
                                >
                                    <v-text-field
                                        v-model="table.external_id"
                                        class="pa-4"
                                        type="text"
                                        label="Pesquisa"
                                        :autofocus="true"
                                    ></v-text-field>
                                    <v-btn
                                        @click="table.external_id = ''"
                                        style="border-color: var(--blue-500); color:var(--blue-500); "
                                        outlined
                                        raised
                                        x-small
                                        >Limpar
                                    </v-btn>
                                </div>
                            </v-menu>
                        </template>
                        <!--Pesquisa pela Descrição-->
                        <template v-slot:header.name="{ header }">
                            {{ header.text }}

                            <v-menu offset-y :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon
                                            small
                                            :style="{
                                                color: table.name
                                                    ? 'var(--green-500)'
                                                    : ''
                                            }"
                                        >
                                            mdi-filter
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <div
                                    style="background-color: white; width: 280px; padding: 10px"
                                >
                                    <v-text-field
                                        v-model="table.name"
                                        class="pa-4"
                                        type="text"
                                        label="Pesquisa"
                                        :autofocus="true"
                                    ></v-text-field>
                                    <v-btn
                                        @click="table.name = ''"
                                        style="border-color: var(--blue-500); color:var(--blue-500); "
                                        outlined
                                        plain
                                        small
                                        >Limpar
                                    </v-btn>
                                </div>
                            </v-menu>
                        </template>
                        <!--ICONES-->
                        <template v-slot:item.is_new="{ item }">
                            <v-chip
                                v-if="item.is_new"
                                style="background-color: var(--yellow-100)"
                            >
                                <v-icon style="color: var(--yellow-400)"
                                    >mdi-star</v-icon
                                >
                            </v-chip>
                        </template>

                        <!--Pesquisa pela linha-->
                        <template v-slot:header.parent_name="{ header }">
                            {{ header.text }}

                            <v-menu offset-y :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon
                                            small
                                            :style="{
                                                color: table.parent_name
                                                    ? 'var(--green-500)'
                                                    : ''
                                            }"
                                        >
                                            mdi-filter
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <div
                                    style="background-color: white; width: 280px; padding: 10px"
                                >
                                    <v-text-field
                                        v-model="table.parent_name"
                                        class="pa-4"
                                        type="text"
                                        label="Pesquisa"
                                        :autofocus="true"
                                    ></v-text-field>
                                    <v-btn
                                        @click="table.parent_name = ''"
                                        style="border-color: var(--blue-500); color:var(--blue-500); "
                                        outlined
                                        plain
                                        small
                                        >Limpar
                                    </v-btn>
                                </div>
                            </v-menu>
                        </template>
                        <!--Pesquisa pela Marca-->
                        <template v-slot:header.brand="{ header }">
                            {{ header.text }}

                            <v-menu offset-y :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon
                                            small
                                            :style="{
                                                color: table.brand
                                                    ? 'var(--green-500)'
                                                    : ''
                                            }"
                                        >
                                            mdi-filter
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <div
                                    style="background-color: white; width: 280px; padding: 10px"
                                >
                                    <v-text-field
                                        v-model="table.brand"
                                        class="pa-4"
                                        type="text"
                                        label="Pesquisa"
                                        :autofocus="true"
                                    ></v-text-field>
                                    <v-btn
                                        @click="table.brand = ''"
                                        style="border-color: var(--blue-500); color:var(--blue-500); "
                                        outlined
                                        plain
                                        small
                                        >Limpar
                                    </v-btn>
                                </div>
                            </v-menu>
                        </template>
                        <!--Pesquisa pela Ref-->
                        <template v-slot:header.reference_number="{ header }">
                            {{ header.text }}

                            <v-menu offset-y :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon
                                            small
                                            :style="{
                                                color: table.reference_number
                                                    ? 'var(--green-500)'
                                                    : ''
                                            }"
                                        >
                                            mdi-filter
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <div
                                    style="background-color: white; width: 280px; padding: 10px"
                                >
                                    <v-text-field
                                        v-model="table.reference_number"
                                        class="pa-4"
                                        type="text"
                                        label="Pesquisa"
                                        :autofocus="true"
                                    ></v-text-field>
                                    <v-btn
                                        @click="table.reference_number = ''"
                                        style="border-color: var(--blue-500); color:var(--blue-500); "
                                        outlined
                                        plain
                                        small
                                        >Limpar
                                    </v-btn>
                                </div>
                            </v-menu>
                        </template>
                        <!--Pesquisa pela Data inicial-->
                        <template
                            v-slot:header.datetime_first_purchase="{ header }"
                        >
                            {{ header.text }}

                            <v-menu offset-y :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon
                                            small
                                            :style="{
                                                color: table.datetime_first_purchase
                                                    ? 'var(--green-500)'
                                                    : ''
                                            }"
                                        >
                                            mdi-filter
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <div
                                    style="background-color: white; width: 280px; padding: 10px"
                                >
                                    <v-text-field
                                        v-model="table.datetime_first_purchase"
                                        class="pa-4"
                                        type="date"
                                        label="Pesquisa"
                                        :autofocus="true"
                                    ></v-text-field>
                                    <v-btn
                                        @click="
                                            table.datetime_first_purchase = ''
                                        "
                                        style="border-color: var(--blue-500); color:var(--blue-500); "
                                        outlined
                                        plain
                                        small
                                        >Limpar
                                    </v-btn>
                                </div>
                            </v-menu>
                        </template>
                        <!--Pesquisa pela Data final-->
                        <template
                            v-slot:header.datetime_last_purchase="{ header }"
                        >
                            {{ header.text }}

                            <v-menu offset-y :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon
                                            small
                                            :style="{
                                                color: table.datetime_last_purchase
                                                    ? 'var(--green-500)'
                                                    : ''
                                            }"
                                        >
                                            mdi-filter
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <div
                                    style="background-color: white; width: 280px; padding: 10px"
                                >
                                    <v-text-field
                                        v-model="table.datetime_last_purchase"
                                        class="pa-4"
                                        type="date"
                                        label="Pesquisa"
                                        :autofocus="true"
                                    ></v-text-field>
                                    <v-btn
                                        @click="
                                            table.datetime_last_purchase = ''
                                        "
                                        style="border-color: var(--blue-500); color:var(--blue-500); "
                                        outlined
                                        plain
                                        small
                                        >Limpar
                                    </v-btn>
                                </div>
                            </v-menu>
                        </template>
                        <!--Pesquisa pela Situação-->
                        <template v-slot:header.status="{ header }">
                            {{ header.text }}

                            <v-menu offset-y :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon
                                            small
                                            :style="{
                                                color: table.status
                                                    ? 'var(--green-500)'
                                                    : ''
                                            }"
                                        >
                                            mdi-filter
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <div
                                    style="background-color: white; width: 280px; padding: 10px"
                                >
                                    <v-text-field
                                        v-model="table.status"
                                        class="pa-4"
                                        type="text"
                                        label="Pesquisa"
                                        :autofocus="true"
                                    ></v-text-field>
                                    <v-btn
                                        @click="table.status = ''"
                                        style="border-color: var(--blue-500); color:var(--blue-500); "
                                        outlined
                                        plain
                                        small
                                        >Limpar
                                    </v-btn>
                                </div>
                            </v-menu>
                        </template>
                        <!--Pesquisa pela Curva-->
                        <template v-slot:header.curve="{ header }">
                            {{ header.text }}

                            <v-menu offset-y :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon
                                            small
                                            :style="{
                                                color: table.curve
                                                    ? 'var(--green-500)'
                                                    : ''
                                            }"
                                        >
                                            mdi-filter
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <div
                                    style="background-color: white; width: 280px; padding: 10px"
                                >
                                    <v-text-field
                                        v-model="table.curve"
                                        class="pa-4"
                                        type="text"
                                        label="Pesquisa"
                                        :autofocus="true"
                                    ></v-text-field>
                                    <v-btn
                                        @click="table.curve = ''"
                                        style="border-color: var(--blue-500); color:var(--blue-500); "
                                        outlined
                                        plain
                                        small
                                        >Limpar
                                    </v-btn>
                                </div>
                            </v-menu>
                        </template>
                    </v-data-table>
                </v-card>

                <div class="text-center pt-3 pb-2" v-else>
                    <img src="loader.svg" style="width: 100px; height: 100px" />
                </div>
            </template>

            <template slot="footer">
                <v-container>
                    <v-row
                        no-gutters
                        justify="center"
                        justify-lg="end"
                        align="center"
                    >
                        <v-col cols="12" lg="auto" class="justify-center">
                            <p class="card-category">
                                Mostrando
                                <select
                                    id="numberItemPage"
                                    v-model="detailsPagination.perPage"
                                >
                                    <option value="20">20</option>
                                    <option value="40">40</option>
                                    <option value="60">60</option>
                                    <option value="80">80</option>
                                    <option value="100">100</option>
                                </select>
                                itens de um total de {{ curveDetailsTotal }}.
                            </p>
                        </v-col>
                        <v-col cols="12" lg="auto" class="justify-center">
                            <pagination
                                class="pagination-no-border pagination-success"
                                v-model="detailsPagination.currentPage"
                                :per-page="detailsPagination.perPage"
                                :total="curveDetailsTotal"
                            >
                            </pagination>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
        </VuetifyModal>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'
import {
    Pagination,
    Modal,
    VuetifyModal,
    VuetifyDraggableTreeview
} from '@/components'

import Utils from '@/utils'
import { Curve as Model } from '@/models/assortment.model'
import Filter from '@/models/assortmentfilter.model'
import Node from '@/models/node.model'

import MaximizeAndMinimize from '@/components/Maximize/MaximizeAndMinimize.vue'
import BaseStock from '@/components/Charts/BaseStock'
import DependencyWheel from '@/components/Charts/DependencyWheel'
import HistogramCurves from '@/components/Charts/HistogramCurves'
import PieCurves from '@/components/Charts/PieCurves'
import TreeMapCurvesCubage from '@/components/Charts/TreeMapCurvesCubage'
import TreeMapCurvesCubageMoney from '@/components/Charts/TreeMapCurvesCubageMoney'
import VUMeter from '@/components/Charts/VUMeter'
import HistogramStockCurves from '@/components/Charts/HistogramStockCurves'

const model = 'assortment'

function checkboxToggle(checkbox) {
    const { field, isChecked } = checkbox
    const lastWord = field.substr(field.indexOf(' ') + 1)

    return {
        ...checkbox,
        field:
            field === `Com ${lastWord}` ? `Sem ${lastWord}` : `Com ${lastWord}`,
        isChecked: !isChecked
    }
}

function Range(name) {
    this.track = name
    this.isChecked = true
}

function Headers(
    text,
    key,
    value,
    align = 'center',
    divider = true,
    filterable = true
) {
    this.text = text
    this.key = key
    this.value = value
    this.align = align
    this.divider = divider
    this.filterable = filterable
}

const coverageHistogramCategories = [
    new Range('0-30'),
    new Range('31-60'),
    new Range('61-90'),
    new Range('91-infinito')
]

const lastEntryHistogramCategories = [
    new Range('0-30'),
    new Range('31-60'),
    new Range('61-90'),
    new Range('91-120'),
    new Range('121-150'),
    new Range('151-180'),
    new Range('181-infinito')
]

export default {
    async created() {
        this.width = window.screen.width - 30

        await this.readDcs() // must be available when filter is loaded
        this.readPlaces() // read states
        // don't read filters before tree node selection
        await this.readFilters()
        this.selectedFilter = 0
        await this.loadFilterInfo()
        await this.applyFilter()
    },
    components: {
        Modal,
        VuetifyModal,
        'v-draggable-treeview': VuetifyDraggableTreeview,
        Pagination,
        stock: BaseStock,
        dependencyWheel: DependencyWheel,
        histogramCurves: HistogramCurves,
        pieCurves: PieCurves,
        treeMapCurvesCubage: TreeMapCurvesCubage,
        treeMapCurvesCubageMoney: TreeMapCurvesCubageMoney,
        vuMeter: VUMeter,
        histogramStockCurves: HistogramStockCurves,
        Multiselect,
        MaximizeAndMinimize
    },
    computed: {
        ...mapState({
            assortmentData: state => state['assortment'],
            _brands: state => state['products'].brands,
            curvesData: state => state['assortment'].curves,
            curvesLoading: state => state['assortment'].curvesLoading,
            curvesMiniDCLoading: state =>
                state['assortment'].curvesMiniDCLoading,
            curveDetailsData: state => state['assortment'].curveDetails,
            curveDetailsLoading: state =>
                state['assortment'].curveDetailsLoading,
            filters: state => state['assortment'].filters,
            treePage: state => state['nodes'].page,
            treeAncestors: state => state['nodes'].ancestors,
            branchesData: state => state['branches'].nameIds,
            dcsData: state => state['branches'].dcs,
            _statesData: state => state['places'].states,
            _citiesData: state => state['places'].cities,
            readingCities: state => state['places'].readingCities,
            readingStates: state => state['places'].readingStates,
            curvesHistogramData: state => state['assortment'].curvesHistogram,
            curvesPieHistogramData: state => state['assortment'].curves,
            curvesTreeMapHistogramData: state => state['assortment'].curves,
            curvesTreeMapMoneyHistogramData: state =>
                state['assortment'].curves,
            curvesHistogramLoading: state =>
                state['assortment'].curvesHistogramLoading
        }),

        tableColumnVisible() {
            let columns = _.cloneDeep(this.assortmentColumnNames)
            Object.keys(columns).forEach(key => {
                if (!this.assortmentColumnVisible[key]) {
                    delete columns[key]
                }
            })
            return columns
        },
        filterLiked() {
            return this.filters.filter(x => x.liked)
        },
        filterUnLiked() {
            return this.filters.filter(x => !x.liked)
        },
        treeData() {
            return [{ name: 'Todos os itens', id: null }]
        },
        nodeTotal() {
            return this.treePage.count
        },
        anyFilterError() {
            return this.priceError
        },
        priceError() {
            return (
                this.selectedHistoryFilterMinPrice &&
                this.selectedHistoryFilterMaxPrice &&
                Number(this.selectedHistoryFilterMinPrice) >
                    Number(this.selectedHistoryFilterMaxPrice)
            )
        },
        curvesDataStock() {
            if (!this.assortmentData.curves) return

            var normal = []
            var news = []
            var discontinuing = []
            var discontinued = []
            var obsolete = []
            var tc = []
            var tcTarget = []
            this.assortmentData.curves
                .filter(curve => curve.curve != 'Total')
                .forEach(curve => {
                    normal.push(
                        curve.stock_cost // -
                        // curve.stock_new_abs -
                        // curve.stock_discontinuing_abs -
                        // curve.stock_discontinued_abs
                    )
                    news.push(curve.stock_new_abs)
                    discontinuing.push(curve.stock_discontinuing_abs)
                    discontinued.push(curve.stock_discontinued_abs)
                    obsolete.push(curve.stock_obsolete_abs)
                    tc.push(curve.stock_coverage)
                    tcTarget.push(
                        curve.stock_coverage != 'Inf.'
                            ? curve.stock_coverage_meta
                            : 'Inf.'
                    )
                })
            return {
                normal,
                news,
                discontinuing,
                discontinued,
                obsolete,
                tc,
                tcTarget
            }
        },
        curvesHistogramDataFilter() {
            if (!this.curvesHistogram) return

            let data = [this.curvesHistogram, this.checkboxCubageChart]
            return data
        },
        curvesHistogramTreeMapDataFilter() {
            if (!this.curvesTreeMapHistogramData) return

            let data = [
                this.curvesTreeMapHistogramData,
                this.checkboxCubageTreeChart
            ]
            return data
        },
        curvesHistogramTreeMapMoneyDataFilter() {
            if (!this.curvesTreeMapMoneyHistogramData) return

            let data = [
                this.curvesTreeMapMoneyHistogramData,
                this.checkboxCubageTreeMoneyChart
            ]
            return data
        },
        curvesDataDependencyWheel() {
            if (!this.assortmentData.curves) return

            let stock = 0
            let stock_and_active = 0
            let stock_and_new = 0
            let stock_and_obsolete = 0
            let stock_and_discontinuing = 0
            let stock_and_discontinued = 0
            let no_stock = 0
            let no_stock_and_inactive = 0
            let no_stock_and_new = 0
            let no_stock_and_discontinuing = 0
            let no_stock_and_discontinued = 0
            let no_stock_and_obsolete = 0
            let new_ = 0
            let obsolete = 0
            let obsolete_and_discontinuing = 0
            let obsolete_and_discontinued = 0
            let discontinuing = 0
            let discontinued = 0

            this.assortmentData.curves
                .filter(
                    curve =>
                        curve.curve != 'Total' &&
                        this.checkedNamesDependencyWheel.filter(
                            elem => elem == curve.curve
                        ).length > 0
                )
                .forEach(curve => {
                    stock += curve.items_in_stock ? curve.items_in_stock : 0
                    stock_and_active += curve.stock_and_active
                        ? curve.stock_and_active
                        : 0
                    stock_and_new += curve.stock_and_new
                        ? curve.stock_and_new
                        : 0
                    stock_and_obsolete += curve.stock_and_obsolete
                        ? curve.stock_and_obsolete
                        : 0
                    stock_and_discontinuing += curve.stock_and_discontinuing
                        ? curve.stock_and_discontinuing
                        : 0
                    stock_and_discontinued += curve.stock_and_discontinued
                        ? curve.stock_and_discontinued
                        : 0
                    no_stock += curve.items_no_stock ? curve.items_no_stock : 0
                    no_stock_and_inactive += curve.no_stock_and_inactive
                        ? curve.no_stock_and_inactive
                        : 0
                    no_stock_and_new += curve.no_stock_and_new
                        ? curve.no_stock_and_new
                        : 0
                    no_stock_and_discontinuing += curve.no_stock_and_discontinuing
                        ? curve.no_stock_and_discontinuing
                        : 0
                    no_stock_and_discontinued += curve.no_stock_and_discontinued
                        ? curve.no_stock_and_discontinued
                        : 0
                    no_stock_and_obsolete += curve.no_stock_and_obsolete
                        ? curve.no_stock_and_obsolete
                        : 0

                    new_ += curve.items_new ? curve.items_new : 0
                    obsolete += curve.items_obsolete ? curve.items_obsolete : 0
                    obsolete_and_discontinuing += curve.obsolete_and_discontinuing
                        ? curve.obsolete_and_discontinuing
                        : 0
                    obsolete_and_discontinued += curve.obsolete_and_discontinued
                        ? curve.obsolete_and_discontinued
                        : 0
                    discontinuing += curve.items_discontinuing
                        ? curve.items_discontinuing
                        : 0
                    discontinued += curve.items_discontinued
                        ? curve.items_discontinued
                        : 0
                })

            let data = [
                [
                    stock,
                    0,
                    stock_and_active,
                    0,
                    stock_and_new,
                    stock_and_obsolete,
                    stock_and_discontinuing,
                    stock_and_discontinued
                ],
                [
                    0,
                    no_stock,
                    0,
                    no_stock_and_inactive,
                    no_stock_and_new,
                    no_stock_and_obsolete,
                    no_stock_and_discontinuing,
                    no_stock_and_discontinued
                ],
                [0, 0, stock_and_active, 0, 0, 0, 0, 0],
                [0, 0, 0, no_stock_and_inactive, 0, 0, 0, 0],
                [0, 0, 0, 0, new_, 0, 0, 0],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    obsolete,
                    obsolete_and_discontinuing,
                    obsolete_and_discontinued
                ],
                [0, 0, 0, 0, 0, 0, discontinuing, 0],
                [0, 0, 0, 0, 0, 0, 0, discontinued]
            ]

            return data
        },
        curveDataVUMeter() {
            if (
                !this.assortmentData.curves ||
                this.assortmentData.curves.length == 0
            )
                return

            return this.vuMeterDefinitions.map(definition => {
                let curve = this.assortmentData.curves.filter(
                    curve => curve.curve == definition.curve
                )[0]
                if (curve) {
                    if (definition.meta == 0) {
                        if (curve.stock_percentual > 20) return 20.5
                        else if (curve.stock_percentual < -20) return -20.5
                    } else if (curve.stock_percentual > definition.meta * 2)
                        return definition.meta * 2 + 0.5
                    // minimum percentual is 0, no need to limit it
                    return curve.stock_percentual
                } else return 0
            })
        },
        checkedNamesDependencyWheel() {
            return this.checkboxDependencyWheelChart
                .filter(item => item.isChecked)
                .map(item => item.curve)
        },
        curveDetailsTotal() {
            return this.curveDetailsData.count
        },
        detailModalHeaderTitle() {
            let text = this.detailModalItem.curve
                ? this.detailModalItem.curve.replaceAll('|', ', ')
                : ['AA', 'A', 'B', 'C', 'CC'].join(', ')

            if (this.detailModalItem.last_entry_track) {
                text = text + ' / ' + this.detailModalItem.last_entry_track
            } else if (this.detailModalItem.tc_track) {
                text = text + ' / ' + this.detailModalItem.tc_track
            }

            return `${this.selectedHistoryFilter.name} / ${text}`
        }
    },
    data() {
        return {
            search: '',
            table: {
                external_id: '',
                name: '',
                is_new: '',
                parent_name: '',
                brand: '',
                reference_number: '',
                datetime_first_purchase: '',
                datetime_last_purchase: '',
                status: '',
                balance_total: '',
                balance_cost_total: '',
                cost_percentage: '',
                tc_item: '',
                cubage_id: '',
                curve: '',
                ads: ''
            },
            headers: [
                new Headers('Cod.', 'external_id', 'external_id'),
                new Headers('Desc.', 'name', 'name'),
                new Headers('Class.', 'is_new', 'is_new'),
                new Headers('Linha.', 'parent_name', 'parent_name'),
                new Headers('Marca.', 'brand', 'brand'),
                new Headers('Ref.', 'reference_number', 'reference_number'),
                new Headers(
                    'Prim. Ent.',
                    'datetime_first_purchase',
                    'datetime_first_purchase'
                ),
                new Headers(
                    'Ult. Ent.',
                    'datetime_last_purchase',
                    'datetime_last_purchase'
                ),
                new Headers('Sit.', 'status', 'status'),
                new Headers('Qtd.', 'balance_total', 'balance_total'),
                new Headers('R$.', 'balance_cost_total', 'balance_cost_total'),
                new Headers('%', 'cost_percentage', 'cost_percentage'),
                new Headers('TC.', 'tc_item', 'tc_item'),
                new Headers('Cub.', 'cubage_id', 'cubage_id'),
                new Headers('Curva', 'curve', 'curve')
            ],
            curvesHistogram: [],
            branch_type: [],
            width: 0,
            filtersGlobals: null,
            brandTermSearch: '',
            selectedHistoryFilter: null,
            selectedHistoryFilterName: null,
            selectedHistoryFilterNone: null,
            selectedHistoryFilterNodeName: null,
            selectedHistoryFilterDcs: [],
            selectedHistoryFilterMinPrice: null,
            selectedHistoryFilterMaxPrice: null,
            filterDirty: false,
            filterModal: false,
            filterProvider: '',
            treeModal: false,
            assortmentColumnNames: Model.fieldNames,
            assortmentClasses: Model.fieldClasses,
            assortmentColumnClickable: Model.clickableFields,
            assortmentTypes: Model.fieldTypes,
            assortmentColumnVisible: Model.visibleFields,
            selectedNode: null,
            selectedNodeName: 'Selecione um item da árvore de sortimento',
            nodePagination: {
                perPage: parseInt(process.env.VUE_APP_DEFAULT_PAGE_SIZE),
                currentPage: 1,
                total: 0
            },
            detailModal: false,
            stockChart: 'stock',
            dependencyWheelChart: 'dependencyWheel',
            vuMeterChart: 'vuMeter',
            histogramCurves: 'histogramCurves',
            pieCurves: 'pieCurves',
            treeMapCurvesCubage: 'treeMapCurvesCubage',
            treeMapCurvesCubageMoney: 'treeMapCurvesCubageMoney',
            histogramStockCurves: 'histogramStockCurves',

            dependencyWheelNames: [
                'Est.',
                'Sem. Est.',
                'Em linha',
                'Inativo',
                'Novo',
                'Obs.',
                'Em. Desc.',
                'Desc.'
            ],
            stockMoneyCoverageRanges: coverageHistogramCategories,
            stockCubageCoverageRanges: coverageHistogramCategories,
            stockMoneyLastEntryRanges: lastEntryHistogramCategories,
            stockCubageLastEntryRanges: lastEntryHistogramCategories,
            checkboxDependencyWheelChart: [
                {
                    curve: 'AA',
                    isChecked: true
                },
                {
                    curve: 'A',
                    isChecked: true
                },
                {
                    curve: 'B',
                    isChecked: true
                },
                {
                    curve: 'C',
                    isChecked: true
                },
                {
                    curve: 'CC',
                    isChecked: true
                }
            ],
            checkboxCubageChart: {
                field: 'Com Novos',
                isChecked: true
            },
            checkboxCubagePieChart: {
                field: 'Com Novos',
                isChecked: true
            },
            checkboxCubageTreeChart: {
                field: 'Com Novos',
                isChecked: true
            },
            checkboxCubageTreeMoneyChart: {
                field: 'Com Novos',
                isChecked: true
            },
            newItems: {
                field: 'Com itens novos',
                isChecked: true
            },
            checkBoxMiniDC: {
                field: 'Mini-CDS',
                isChecked: false,
                filter: 'md'
            },
            checkboxCubageChartMiniDC: {
                field: 'Com Mini-CDs',
                isChecked: true,
                branch_type: 'M'
            },
            filterDCCubage: {
                field: 'Com CDs',
                isChecked: true,
                branch_type: 'D'
            },
            vuMeterDefinitions: [
                {
                    curve: 'AA',
                    greenPercentage: 10,
                    yellowPercentage: 20,
                    meta: 50
                },
                {
                    curve: 'A',
                    greenPercentage: 10,
                    yellowPercentage: 20,
                    meta: 35
                },
                {
                    curve: 'B',
                    greenPercentage: 10,
                    yellowPercentage: 20,
                    meta: 10
                },
                {
                    curve: 'C',
                    greenPercentage: 10,
                    yellowPercentage: 20,
                    meta: 5
                },
                {
                    curve: 'CC',
                    greenPercentage: 10,
                    yellowPercentage: 20,
                    meta: 0,
                    credits: true
                }
            ],
            detailModalField: 'items_registered',
            detailModalItem: {
                curve: 'AA'
            },
            detailCurrentStockCost: 1,
            detailsPagination: {
                perPage: parseInt(20),
                currentPage: 1,
                total: 0
            }
        }
    },
    methods: {
        ...mapActions({
            clearEntities: 'assortment/clear',
            readEntities: 'assortment/read',
            // _filterMiniDCs: 'assortment/filterMiniDCs',
            readHistogram: 'assortment/readHistogram',
            readDetails: 'assortment/readDetails',
            createFilter: 'assortment/createFilter',
            readFilters: 'assortment/readFilters',
            updateFilter: 'assortment/updateFilter',
            deleteFilter: 'assortment/deleteFilter',
            likeFilter: 'assortment/likeFilter',
            unlikeFilter: 'assortment/unlikeFilter',
            updateLastSeenFilter: 'assortment/updateLastSeenFilter',
            downloadFile: 'assortment/downloadFile',
            readBrands: 'products/readBrands'
        }),
        ...mapActions('nodes', {
            readTreeNodes: 'read',
            readTreeAncestors: 'readAncestors'
        }),
        ...mapActions('branches', {
            readBranchNameIds: 'readNameIds',
            readDcs: 'readDcs'
        }),
        ...mapActions('places', {
            readPlaces: 'read'
        }),
        clearInputsFilter() {
            if (this.search.trim().length !== 0) {
                this.search = ''
            }
            for (const key in this.table) {
                if (this.table.hasOwnProperty(key)) {
                    this.table[key] = ''
                }
            }
        },
        handleFilterExternal(item) {
            return item.external_id
                .toString()
                .toLowerCase()
                .includes(this.table.external_id.toString().toLowerCase())
        },
        handleFilterName(item) {
            return item.name
                .toString()
                .toLowerCase()
                .includes(this.table.name.toString().toLowerCase())
        },
        handleFilterBrand(item) {
            return item.brand
                .toString()
                .toLowerCase()
                .includes(this.table.brand.toString().toLowerCase())
        },
        handleFilterParentName(item) {
            return item.parent_name
                .toString()
                .toLowerCase()
                .includes(this.table.parent_name.toString().toLowerCase())
        },
        handleFilterReferenceNumber(item) {
            return item.reference_number
                .toString()
                .toLowerCase()
                .includes(this.table.reference_number.toString().toLowerCase())
        },
        handleFilterDateFirst(item) {
            return item.datetime_first_purchase
                .toString()
                .toLowerCase()
                .includes(
                    this.table.datetime_first_purchase.toString().toLowerCase()
                )
        },
        handleFilterDateLast(item) {
            return item.datetime_last_purchase
                .toString()
                .toLowerCase()
                .includes(
                    this.table.datetime_last_purchase.toString().toLowerCase()
                )
        },
        handleFilterStatus(item) {
            return item.status
                .toString()
                .toLowerCase()
                .includes(this.table.status.toString().toLowerCase())
        },
        handleFilterCurve(item) {
            return item.curve
                .toString()
                .toLowerCase()
                .includes(this.table.curve.toString().toLowerCase())
        },

        modalDataVue() {
            return this.curveDetailsData.results.map(item => {
                return {
                    external_id: item.external_id,
                    name: item.name,
                    parent_name: item.parent_name,
                    brand: item.brand.name,
                    reference_number: item.reference_number,
                    datetime_first_purchase: item.datetime_first_purchase,
                    datetime_last_purchase: item.datetime_last_purchase,
                    status:
                        item.status === 'A'
                            ? 'Em linha'
                            : item.status === 'O'
                            ? 'Descontinuado'
                            : item.status === 'I'
                            ? 'Inativo'
                            : item.status === 'D'
                            ? 'Em descontinuação'
                            : '',
                    balance_total: item.balance_total,
                    balance_cost_total: Number(
                        item.balance_cost_total
                    ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }),
                    cost_percentage: Number(
                        this.detailCurrentStockCost &&
                            this.detailCurrentStockCost > 0
                            ? (100 * item.balance_cost_total) /
                                  this.detailCurrentStockCost
                            : 0
                    ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }),
                    tc_item:
                        item.tc_item != 'Inf.'
                            ? Number(item.tc_item).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                              })
                            : 'Inf.',
                    cubage_id: item.cubage_id,
                    curve: item.curve,
                    ads: Number(item.ads).toLocaleString(2),
                    is_new: Boolean(item.is_new)
                }
            })
        },
        checkboxIsSelected(handleCheck, index) {
            this[handleCheck] = this[handleCheck].map((item, i) => {
                return i === index
                    ? { ...item, isChecked: !item.isChecked }
                    : item
            })
        },
        filterNewItems(value) {
            this.newItems = checkboxToggle(this.newItems)
            this.filterProvider = this.newItemsValidation()
        },
        newItemsValidation() {
            return this.newItems.isChecked ? null : 0
        },
        objectKeys(data) {
            return Object.keys(data)
        },
        setDcs(dcs) {
            this.selectedHistoryFilterDcs = []
            if (!dcs) return
            dcs.split(',').forEach(dc => {
                this.selectedHistoryFilterDcs.push(
                    this.dcsData.find(o => o.external_id == dc)
                )
            })
        },
        isDcsEqual(dcsStr) {
            if (!dcsStr) return !this.selectedHistoryFilterDcs.length
            let dcs = dcsStr.split(',')
            if (dcs.length != this.selectedHistoryFilterDcs.length) return false
            for (let dc of dcs) {
                if (
                    !this.selectedHistoryFilterDcs.find(
                        o => o.external_id == dc
                    )
                )
                    return false
            }
            return true
        },

        async selectHistoryFilter(filter) {
            this.selectedHistoryFilterName = filter.name
            this.setDcs(filter.dcs)
            this.selectedHistoryFilterMinPrice = filter.price_min
            this.selectedHistoryFilterMaxPrice = filter.price_max
            this.filterProvider = filter.brand

            if (filter.parent) {
                await this.readTreeAncestors({ id: filter.parent })
                this.selectedHistoryFilterNode = this.treeAncestors[
                    this.treeAncestors.length - 1
                ]

                this.selectedHistoryFilterNodeName = ''
                this.treeAncestors.forEach((ancestor, index) => {
                    if (index > 0) this.selectedHistoryFilterNodeName += ' > '
                    this.selectedHistoryFilterNodeName += ancestor.name
                })
            } else {
                this.selectedHistoryFilterNodeName = 'Todos os itens'
                this.selectedHistoryFilterNode = new Node()
            }
            this.filterDirty = false
            this.selectedHistoryFilter = filter
            await this.applyFilter()
        },

        unlike(filterId) {
            if (!this.unlikeFilter(filterId)) {
                this.filters.map(filter => {
                    if (filter.id == filterId) {
                        filter.liked = false
                    }
                })
            }
        },
        like(filterId) {
            if (!this.likeFilter(filterId)) {
                this.filters.map(filter => {
                    if (filter.id == filterId) {
                        filter.liked = true
                    }
                })
            }
        },
        preProcessFilter() {
            if (!this.selectedHistoryFilter) {
                this.filterDirty =
                    this.selectedHistoryFilterDcs.length ||
                    this.selectedHistoryFilterMinPrice ||
                    this.selectedHistoryFilterMaxPrice ||
                    this.filterProvider ||
                    (this.selectedHistoryFilterNode &&
                        this.selectedHistoryFilterNode['id'])
            } else {
                this.filterDirty =
                    !this.isDcsEqual(this.selectedHistoryFilter['dcs']) ||
                    this.selectedHistoryFilter['price_min'] !=
                        this.selectedHistoryFilterMinPrice ||
                    this.selectedHistoryFilter['price_max'] !=
                        this.selectedHistoryFilterMaxPrice ||
                    this.selectedHistoryFilter['brand'] !=
                        this.filterProvider ||
                    (this.selectedHistoryFilterNode &&
                        this.selectedHistoryFilter['parent'] !==
                            this.selectedHistoryFilterNode['id']) ||
                    this.selectedHistoryFilter['is_new'] !=
                        this.newItems.isChecked
            }
        },
        posProcessFilter() {
            let hasFilter = this.filters.filter(
                item => item.name == this.selectedHistoryFilterName
            )
            if (hasFilter && hasFilter.length > 0) {
                this.selectedHistoryFilter = hasFilter[0]
                this.filterDirty = false
            }
        },
        changeName() {
            if (this.filterDirty) {
                let filterName = ''
                if (
                    this.selectedHistoryFilterNode != null &&
                    this.selectedHistoryFilterNodeName != null
                ) {
                    filterName += this.selectedHistoryFilterNodeName
                }
                if (
                    this.selectedHistoryFilterMinPrice != null &&
                    this.selectedHistoryFilterMaxPrice != null
                ) {
                    if (filterName.length > 0) filterName += ' / '
                    filterName +=
                        this.selectedHistoryFilterMinPrice +
                        ' - ' +
                        this.selectedHistoryFilterMaxPrice
                }

                if (this.selectedHistoryFilterDcs.length) {
                    if (filterName.length > 0) filterName += ' / '

                    filterName += this.selectedHistoryFilterDcs
                        .map(o => o.external_id)
                        .join()
                }

                if (this.filterProvider) {
                    filterName += ' / '
                    filterName += this.filterProvider
                }

                this.selectedHistoryFilterName = filterName
            } else {
                this.selectedHistoryFilterName = this.selectedHistoryFilter[
                    'name'
                ]
            }
        },
        filterModalOpen(state) {
            if (!state) {
                this.filterEditable = false
            }
            this.filterModal = state
        },
        treeModalOpen(state) {
            this.treeModal = state
        },

        preDetailModalOpen(item, field = this.detailModalField, page) {
            let item_copy = _.cloneDeep(item)

            let total_field = {
                items_registered: 'total_cost',
                items_in_stock: 'stock_cost',
                items_no_stock: 'no_stock_cost',
                items_active: 'stock_and_active_abs',
                items_inactive: 'no_stock_and_inactive_abs',
                items_new: 'stock_new_abs',
                items_obsolete: 'stock_obsolete_abs',
                items_discontinuing: 'stock_discontinuing_abs',
                items_discontinued: 'stock_discontinued_abs'
            }

            item_copy = {
                ...item_copy,
                stock_cost: item_copy[total_field[field]]
            }

            this.detailModalOpen(true, item_copy, field, page)
        },
        async detailModalOpen(state, item, field, page, perPage) {
            if (state) {
                this.detailModalField = field
                this.detailCurrentStockCost = item.stock_cost
                this.detailModal = true

                await this.filterDetails(item, field, page, perPage)
                document
                    .querySelector('#detail-modal .modal-container')
                    .scrollTo({
                        behavior: 'smooth',
                        left: 0,
                        top: 0
                    }) //.scrollTop = 0
            } else {
                this.detailModal = false
            }
        },

        async filterDetails(item, field, page, perPage) {
            this.detailModalField = field
            this.detailCurrentStockCost = item.stock_cost

            let filter = {
                ...this.selectedHistoryFilter,
                ...item,
                field,
                is_new: this.newItemsValidation()
            }

            if (item.dc) {
                filter.dcs = item.dc
                this.selectedHistoryFilter.name = this.selectedHistoryFilter.name.split(
                    '/'
                )
                this.selectedHistoryFilter.name[2] = ' ' + item.dc
                this.selectedHistoryFilter.name = this.selectedHistoryFilter.name.join(
                    '/'
                )
            }

            this.detailModalItem = filter

            if (page) filter.page = page
            if (perPage) filter.limit = Number(perPage)

            await this.readDetails(filter)
        },

        handleCharts(curve) {
            const item = {
                ...this.selectedHistoryFilter,
                curve
            }

            this.preDetailModalOpen(item)
        },

        async _createFilter(filterPropagation = true) {
            if (this.filterDirty && filterPropagation) {
                let error = await this.createFilter({
                    name: this.selectedHistoryFilterName,
                    dcs: this.selectedHistoryFilterDcs
                        .map(o => o.external_id)
                        .join(),
                    price_min: this.selectedHistoryFilterMinPrice,
                    price_max: this.selectedHistoryFilterMaxPrice,
                    parent: this.selectedHistoryFilterNode.id,
                    brand: this.filterProvider,
                    is_new: this.newItemsValidation()
                })

                if (error) {
                    this.$notify({
                        message: 'Erro ao criar filtro.',
                        icon: 'add_alert',
                        horizontalAlign: 'right',
                        verticalAlign: 'bottom',
                        type: 'danger'
                    })
                } else {
                    this.filterDirty = false
                    this.selectedHistoryFilter[
                        'name'
                    ] = this.selectedHistoryFilterName
                    this.selectedHistoryFilter['dcs'] =
                        this.selectedHistoryFilterDcs.length > 0
                            ? this.selectedHistoryFilterDcs
                                  .map(o => o.external_id)
                                  .join()
                            : ''
                    this.selectedHistoryFilter['price_min'] =
                        this.selectedHistoryFilterMinPrice ?? ''
                    this.selectedHistoryFilter['price_max'] =
                        this.selectedHistoryFilterMaxPrice ?? ''
                    this.selectedHistoryFilter[
                        'parent'
                    ] = this.selectedHistoryFilterNode['id']
                    this.selectedHistoryFilter['brand'] = this.filterProvider
                    this.selectedHistoryFilter[
                        'is_new'
                    ] = this.newItemsValidation()
                }
            } else if (this.selectedHistoryFilter.id != null) {
                let error = await this.updateLastSeenFilter(
                    this.selectedHistoryFilter.id
                )

                if (error) {
                    this.$notify({
                        message: 'Erro ao atualizar filtro.',
                        icon: 'add_alert',
                        horizontalAlign: 'right',
                        verticalAlign: 'bottom',
                        type: 'danger'
                    })
                }
            }
        },
        async loadFilterInfo() {
            this.selectedHistoryFilter = new Filter()
            this.selectedHistoryFilterName = this.selectedHistoryFilter.name
            this.selectedHistoryFilterNode = new Node()
            this.selectedHistoryFilterNodeName = 'Todos os itens'
            this.setDcs(this.selectedHistoryFilter.dcs)
            this.selectedHistoryFilterMinPrice = this.selectedHistoryFilter.price_min
            this.selectedHistoryFilterMaxPrice = this.selectedHistoryFilter.price_max
        },
        async clearFilter() {
            await this.loadFilterInfo()
            await this.applyFilter(false)
        },

        async applyFilter(createFilter = true) {
            await this._createFilter(createFilter)
            this.filtersGlobals = {
                ...this.selectedHistoryFilter,
                is_new: this.newItemsValidation()
            }
            await this.readEntities(this.filtersGlobals)
            await this.readHistogram(this.filtersGlobals)
            this.filterCurvesHistogramData()
        },

        // async filterMiniDC() {
        //     let hasMiniCD = 'M',
        //         notMiniCD = 'D'
        //     let parameter = this.filtersGlobals
        //     this.checkBoxMiniDC.isChecked = !this.checkBoxMiniDC.isChecked

        //     if (this.checkBoxMiniDC.isChecked) {
        //         parameter['branch_type'] = notMiniCD
        //     } else {
        //         parameter['branch_type'] = hasMiniCD
        //     }

        //     this._filterMiniDCs(parameter)
        // },
        async handleInputSearch(e) {
            return await this.readBrands(e)
        },
        async selectTreeChild(item) {
            this.selectedHistoryFilterNode = item
            //this.selectedNodeName = 'Carregando árvore...'
            this.treeModal = false
            await this.readTreeAncestors({ id: item.id })

            if (item.id == null) {
                this.selectedHistoryFilterNodeName = 'Todos os itens'
                this.treeModal = false
            } else {
                this.selectedHistoryFilterNodeName = ''
                this.treeAncestors.forEach((ancestor, index) => {
                    if (index > 0) this.selectedHistoryFilterNodeName += ' > '
                    this.selectedHistoryFilterNodeName += ancestor.name
                })
            }
        },

        async handleDownload() {
            await this._createFilter()
            await this.downloadFile(this.detailModalItem)
        },

        selectBrand(c) {
            this.brandTermSearch = c.name
            this.filterProvider = c.id
        },
        readTreeChild(item) {
            return this.readTreeNodes({ item })
        },
        insertBgColor(item, column) {
            if (item.curve === 'Total') {
                return column
            }
            return null
        },
        matchReference(item, column) {
            // if a column has reference, we have a field with the same name with _meta at the end
            let referenceName = column + '_meta'
            if (!(referenceName in item)) return true // if there is no reference, it matches
            if (item[referenceName] == 0) {
                // if reference is 0 and value is 0 or null
                if (!item[column]) return true
                // it matches if it is 0
                return item[column] == 0
            } else {
                // if reference is not 0 and value is 0 or null, it doesnt match
                if (!item[column]) return false
                let ratio = item[column] / item[referenceName]
                return ratio <= 1.15 && ratio >= 0.85 // 15% deviation
            }
        },

        checkboxDependencyWheelChartToggle(index) {
            this.checkboxDependencyWheelChart = this.checkboxDependencyWheelChart.map(
                (item, i) => {
                    return i === index
                        ? {
                              ...item,
                              isChecked: !item.isChecked
                          }
                        : item
                }
            )
        },

        branchIsChecked(isChecked, branch_type) {
            if (isChecked) this.branch_type.push(branch_type)
            else {
                this.branch_type = this.branch_type.filter(
                    element => element !== branch_type
                )
            }
        },
        async checkboxCubageChartMiniDCToggle() {
            this.checkboxCubageChartMiniDC = checkboxToggle(
                this.checkboxCubageChartMiniDC
            )

            const { isChecked, branch_type } = this.checkboxCubageChartMiniDC
            this.branchIsChecked(isChecked, branch_type)

            this.getHistogramFiltered(this.selectedHistoryFilter)
        },
        async getDCsInCubage() {
            this.filterDCCubage = checkboxToggle(this.filterDCCubage)
            const { isChecked, branch_type } = this.filterDCCubage
            this.branchIsChecked(isChecked, branch_type)

            this.getHistogramFiltered(this.selectedHistoryFilter)
        },
        filterCurvesHistogramData() {
            this.curvesHistogram = this.curvesHistogramData.filter(
                item =>
                    (this.filterDCCubage.isChecked &&
                        this.filterDCCubage.branch_type == item.dc_type) ||
                    (this.checkboxCubageChartMiniDC.isChecked &&
                        this.checkboxCubageChartMiniDC.branch_type ==
                            item.dc_type)
            )
        },
        async getHistogramFiltered(filter) {
            if (parseInt(process.env.VUE_APP_FILTER_HISTOGRAM_BY_API) == 0) {
                filter = { ...filter, branch_types: this.branch_type.join() }
                await this.readHistogram(filter)
            } else {
                this.filterCurvesHistogramData()
            }
        },

        getItem(curve) {
            return this.curvesData.filter(item => item.curve == curve)[0]
        },
        stockChartOnClick(curve, elem) {
            let elems = {
                normal: 'items_in_stock',
                news: 'items_new',
                discontinuing: 'items_discontinuing',
                discontinued: 'items_discontinued',
                obsolete: 'items_obsolete'
            }
            elem = elems[elem]
            if (!elem) return
            this.preDetailModalOpen(this.getItem(curve), elem)
        },
        histogramChartOnPointClick(curve, dc) {
            this.preDetailModalOpen({ ...this.getItem(curve), dc })
        },

        async stockEntriesChartOnPointClick({ name, category }) {
            const item = {
                last_entry_track: category
            }
            this.preDetailModalOpen(item)
        },

        async stockCoveragesChartOnPointClick({ name, category }) {
            const item = {
                tc_track: category
            }
            this.preDetailModalOpen(item)
        },
        treeMapChartOnPointClick(curve) {
            this.preDetailModalOpen(this.getItem(curve))
        },
        dependencyWheelChartOnNodeClick(field) {
            let item = {
                curve: this.checkboxDependencyWheelChart
                    .filter(item => item.isChecked)
                    .map(item => item.curve)
                    .join('|')
            }

            let fields = {
                'Est.': 'items_in_stock',
                'Sem. Est.': 'items_no_stock',
                'Em linha': 'items_active',
                Inativo: 'items_inactive',
                Novo: 'items_new',
                'Obs.': 'items_obsolete',
                'Em. Desc.': 'items_discontinuing',
                'Desc.': 'items_discontinued'
            }
            field = fields[field]
            item.stock_cost = 0

            let total_field = {
                items_in_stock: 'stock_cost',
                items_no_stock: 'no_stock_cost',
                items_active: 'stock_and_active_abs',
                items_inactive: 'no_stock_and_inactive_abs',
                items_new: 'stock_new_abs',
                items_obsolete: 'stock_obsolete_abs',
                items_discontinuing: 'stock_discontinuing_abs',
                items_discontinued: 'stock_discontinued_abs'
            }

            this.checkboxDependencyWheelChart
                .filter(item => item.isChecked)
                .forEach(e => {
                    let value = this.curvesData.filter(
                        item => item.curve == e.curve
                    )[0][total_field[field]]
                    item.stock_cost += value ? value : 0
                })

            if (!field) return

            this.detailModalOpen(true, item, field)
        },
        dependencyWheelChartOnPointClick(from, to) {
            let item = {
                curve: this.checkboxDependencyWheelChart
                    .filter(item => item.isChecked)
                    .map(item => item.curve)
                    .join('|')
            }
            let fields = {
                'Est.': 'items_in_stock',
                'Sem. Est.': 'items_no_stock',
                'Em linha': 'items_active',
                Inativo: 'items_inactive',
                Novo: 'items_new',
                'Obs.': 'items_obsolete',
                'Em. Desc.': 'items_discontinuing',
                'Desc.': 'items_discontinued'
            }

            let total_field = {
                stock_and_new_abs: ['items_in_stock', 'items_new'],
                stock_and_discontinuing_abs: [
                    'items_in_stock',
                    'items_discontinuing'
                ],
                stock_and_discontinued_abs: [
                    'items_in_stock',
                    'items_discontinued'
                ],
                stock_and_obsolete_abs: ['items_in_stock', 'items_obsolete'],
                no_stock_and_new_abs: ['items_no_stock', 'items_new'],
                no_stock_and_discontinuing_abs: [
                    'items_no_stock',
                    'items_discontinuing'
                ],
                no_stock_and_discontinued_abs: [
                    'items_no_stock',
                    'items_discontinued'
                ],
                no_stock_and_obsolete_abs: ['items_no_stock', 'items_obsolete'],
                obsolete_and_discontinuing_abs: [
                    'items_obsolete',
                    'items_discontinuing'
                ],
                obsolete_and_discontinued_abs: [
                    'items_obsolete',
                    'items_discontinued'
                ]
            }
            from = fields[from]
            to = fields[to]

            let stock_cost = Object.keys(total_field).filter(
                a => total_field[a].filter(b => b == to || b == from).length > 1
            )[0]

            item.stock_cost = 0
            this.checkboxDependencyWheelChart
                .filter(item => item.isChecked)
                .forEach(e => {
                    let value = this.curvesData.filter(
                        c => c.curve == e.curve
                    )[0][stock_cost]
                    item.stock_cost += value ? value : 0
                })

            if (!from || !to) return

            this.detailModalOpen(true, item, [from, to].join(','))
        },
        vuMeterOnClick(curve) {
            this.detailModalOpen(true, this.getItem(curve))
        },
        formatNumber: (number, type, shorten) => {
            return Utils.formatNumber(number, type, shorten)
        },
        getDcName: dc => {
            return dc.external_id + ' - ' + dc.name
        },
        handlerAssortmentDataChartToStock(handleCheck, trackKey, valueKey) {
            if (!this.assortmentData.curves) return
            const categories = {}
            this[handleCheck].map(e => {
                if (e.isChecked) categories[e.track] = e.track
            })

            const data = this.assortmentData.curves.map(item => {
                if (item[trackKey]) {
                    const updatedItem = {}
                    updatedItem[trackKey] = item[trackKey]
                        .map((value, index) => {
                            if (categories[value[valueKey]]) {
                                return value
                            }
                        })
                        .filter(track => track)

                    return { ...item, ...updatedItem }
                }
            })
            return data.filter(i => i)
        },
        smartSearch(args) {
            clearTimeout(this._timerId)

            this._timerId = setTimeout(() => {
                const { page, ...rest } = this.detailModalItem
                this.filterDetails({
                    ...rest,
                    ...args,
                    disableLoading: true
                })
            }, 1000)
        }
    },
    watch: {
        brandTermSearch: {
            handler: function(val) {
                if (!val) this.filterProvider = ''
            }
        },
        selectedNode: {
            handler: async function(val) {
                this.selectedFilter = -1
                await this.readFilters({ parent: val })
                this.selectedFilter = 0
            }
        },
        nodePagination: {
            handler: function(val) {
                this.readTreeNodes({ page: val.currentPage })
            },
            deep: true
        },
        detailsPagination: {
            handler: function(val) {
                if (val.perPage) val.perPage = parseInt(val.perPage)
                this.detailModalOpen(
                    true,
                    this.detailModalItem,
                    this.detailModalField,
                    val.currentPage,
                    val.perPage
                )
            },
            deep: true
        },

        selectedHistoryFilterNodeName: {
            handler: function(val) {
                this.preProcessFilter()
                this.changeName()
                this.posProcessFilter()
            }
        },

        selectedHistoryFilterDcs: {
            handler: function(val) {
                this.preProcessFilter()
                this.changeName()
                this.posProcessFilter()
            }
        },

        selectedHistoryFilterMinPrice: {
            handler: function(val) {
                this.preProcessFilter()
                this.changeName()
                this.posProcessFilter()
            }
        },

        selectedHistoryFilterMaxPrice: {
            handler: function(val) {
                this.preProcessFilter()
                this.changeName()
                this.posProcessFilter()
            }
        },

        filterProvider: {
            handler: function(val) {
                this.preProcessFilter()
                this.changeName()
                this.posProcessFilter()
            }
        },

        filterDCCubage: {
            handler: function(val) {
                if (
                    !this.checkboxCubageChartMiniDC.isChecked &&
                    !val.isChecked
                ) {
                    this.checkboxCubageChartMiniDCToggle()
                }
            },
            deep: true
        },

        checkboxCubageChartMiniDC: {
            handler: function(val) {
                if (!this.filterDCCubage.isChecked && !val.isChecked) {
                    this.getDCsInCubage()
                }
            },
            deep: true
        },

        search: {
            handler: function(val) {
                this.smartSearch({ smart_search: val })
            }
        },

        table: {
            handler: function(val) {
                const obj = {}
                Object.entries(val).forEach(entry => {
                    obj[`${entry[0]}_q`] = entry[1]
                })
                this.smartSearch(obj)
            },
            deep: true
        }
    }
}
</script>

<!-- TODO isso devia ser scoped -->
<style lang="css">
img.icon {
    height: 2em;
    width: 2em;
    margin-right: 5px;
}

.hidden-check-box {
    visibility: hidden;
}

.cubage_chart {
    background: white;
    border: 2px solid white;
    border-radius: 12px;
    padding-left: 15px;
    padding-right: 15px;
    margin-bottom: 1rem;
}

.export {
    width: 150px !important;
    font-size: 1em !important;
}

.btn-star {
    border: none;
    background: none;
    cursor: pointer;
}

.md-input {
    width: 100%;
}

.md-table-head {
    text-align: center;
}

.md-table-head-label {
    font-weight: bold;
}

.md-table-head-container {
    text-align: left;
}

#assortmentTable > thead > tr:nth-child(2) {
    text-align: left;
}

td.out-of-reference {
    background: #3c8db9;
    color: #fff;
}

#assortmentTable > tbody > tr:last-child {
    font-weight: bold;
}

.no-hover:hover {
    background-color: initial;
}

.modal-container {
    max-height: 600px;
    max-width: 800px;
    overflow: auto;
}

.cell-drill-down:hover {
    cursor: pointer;
    background: #eee;
}

.md-table-cell {
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border: 1px solid #eee;
}

.md-table-head {
    border: 1px solid #eee;
}

.topper-chart {
    min-height: 500px;
}

.vumeter-remove-border {
    background: #eee;
    box-shadow: 0 0 0 0;
}

.change-auto-padding {
    padding: 2px !important;
}

:root {
    --inStock: #3c8db9; /* Estoque */
    --notStock: #49b29d; /* Não estoque */
    --inLine: #3c8db9; /* Em linha */
    --inactive: #6bf3d8; /* Inativo */
    --newAssortiment: #22526d; /* Novo */
    --obsolet: #ff0000; /* Obsoleto */
    --indiscontinuation: #213169; /* Em descotinuacao */
    --discontinued: #111a3b; /* Descotinuado */
    --color-9: #49b29d; /* TC */
    --color-10: #6bf3d8; /* TC meta */
}

.item .n-0 {
    fill: var(--inStock);
}

.item .n-1 {
    fill: var(--notStock);
}

.item .n-2 {
    fill: var(--inLine);
}

.item .n-3 {
    fill: var(--inactive);
}

.item .n-4 {
    fill: var(--newAssortiment);
}

.item .n-5 {
    fill: var(--obsolet);
}

.item .n-6 {
    fill: var(--indiscontinuation);
}

.item .n-7 {
    fill: var(--discontinued);
}

.item .highcharts-point.p-0-1 {
    fill: var(--inStock);
    opacity: 0.6;
}

.item .highcharts-point.p-0-2 {
    fill: var(--inStock);
    opacity: 0.6;
}

.item .highcharts-point.p-0-3 {
    fill: var(--inStock);
    opacity: 0.6;
}

.item .highcharts-point.p-0-4 {
    fill: var(--inStock);
    opacity: 0.6;
}

.item .highcharts-point.p-0-5 {
    fill: var(--inStock);
    opacity: 0.6;
}

.item .highcharts-point.p-0-6 {
    fill: var(--inStock);
    opacity: 0.6;
}

.item .highcharts-point.p-0-7 {
    fill: var(--inStock);
    opacity: 0.6;
}

.item .highcharts-point.p-0-1:hover {
    opacity: 1;
}

.item .highcharts-point.p-0-2:hover {
    opacity: 1;
}

.item .highcharts-point.p-0-3:hover {
    opacity: 1;
}

.item .highcharts-point.p-0-4:hover {
    opacity: 1;
}

.item .highcharts-point.p-0-5:hover {
    opacity: 1;
}

.item .highcharts-point.p-0-6:hover {
    opacity: 1;
}

.item .highcharts-point.p-0-7:hover {
    opacity: 1;
}

.item .highcharts-point.p-1-1 {
    fill: var(--notStock);
    opacity: 0.6;
}

.item .highcharts-point.p-1-2 {
    fill: var(--notStock);
    opacity: 0.6;
}

.item .highcharts-point.p-1-3 {
    fill: var(--notStock);
    opacity: 0.6;
}

.item .highcharts-point.p-1-4 {
    fill: var(--notStock);
    opacity: 0.6;
}

.item .highcharts-point.p-1-5 {
    fill: var(--notStock);
    opacity: 0.6;
}

.item .highcharts-point.p-1-6 {
    fill: var(--notStock);
    opacity: 0.6;
}

.item .highcharts-point.p-1-7 {
    fill: var(--notStock);
    opacity: 0.6;
}

.item .highcharts-point.p-1-1:hover {
    opacity: 1;
}

.item .highcharts-point.p-1-2:hover {
    opacity: 1;
}

.item .highcharts-point.p-1-3:hover {
    opacity: 1;
}

.item .highcharts-point.p-1-4:hover {
    opacity: 1;
}

.item .highcharts-point.p-1-5:hover {
    opacity: 1;
}

.item .highcharts-point.p-1-6:hover {
    opacity: 1;
}

.item .highcharts-point.p-1-7:hover {
    opacity: 1;
}

.stock .highcharts-color-0 .highcharts-point {
    fill: var(--inStock);
    stroke: var(--inStock);
}

.stock .highcharts-color-1 .highcharts-point {
    fill: var(--newAssortiment);
    stroke: var(--newAssortiment);
}

.stock .highcharts-color-2 .highcharts-point {
    fill: var(--indiscontinuation);
    stroke: var(--indiscontinuation);
}

.stock .highcharts-color-3 .highcharts-point {
    fill: var(--discontinued);
    stroke: var(--discontinued);
}

.stock .highcharts-color-4 .highcharts-point {
    fill: var(--obsolet);
    stroke: var(--obsolet);
}

.stock .highcharts-color-5 .highcharts-point {
    fill: var(--color-9);
    stroke: var(--color-9);
}

.stock .highcharts-color-5 .highcharts-graph {
    stroke: var(--color-9);
}

.stock .highcharts-color-6 .highcharts-point {
    fill: var(--color-10);
    stroke: var(--color-10);
}

.stock .highcharts-color-6 .highcharts-graph {
    stroke: var(--color-10);
}

.item .highcharts-point.p-4-5 {
    fill: var(--obsolet);
    opacity: 0.6;
}

.item .highcharts-point.p-5-6 {
    fill: var(--obsolet);
    opacity: 0.6;
}

.item .highcharts-point.p-5-7 {
    fill: var(--obsolet);
    opacity: 0.6;
}

.item .highcharts-point.p-4-5:hover {
    opacity: 1;
}

.item .highcharts-point.p-5-6:hover {
    opacity: 1;
}

.item .highcharts-point.p-5-7:hover {
    opacity: 1;
}

.adjust-modal-title-text {
    display: flex;
    justify-content: space-between;
    align-content: center;
    width: 100%;
}

/**** MULTISELECT */

fieldset[disabled] .multiselect {
    pointer-events: none;
}

.multiselect__spinner {
    position: absolute;
    right: 1px;
    top: 1px;
    width: 48px;
    height: 35px;
    background: #fff;
    display: block;
}

.multiselect__spinner:before,
.multiselect__spinner:after {
    position: absolute;
    content: '';
    top: 50%;
    left: 50%;
    margin: -8px 0 0 -8px;
    width: 16px;
    height: 16px;
    border-radius: 100%;
    border-color: #3c8db9 transparent transparent;
    border-style: solid;
    border-width: 2px;
    box-shadow: 0 0 0 1px transparent;
}

.multiselect__spinner:before {
    animation: spinning 2.4s cubic-bezier(0.41, 0.26, 0.2, 0.62);
    animation-iteration-count: infinite;
}

.multiselect__spinner:after {
    animation: spinning 2.4s cubic-bezier(0.51, 0.09, 0.21, 0.8);
    animation-iteration-count: infinite;
}

.multiselect__loading-enter-active,
.multiselect__loading-leave-active {
    transition: opacity 0.4s ease-in-out;
    opacity: 1;
}

.multiselect__loading-enter,
.multiselect__loading-leave-active {
    opacity: 0;
}

.multiselect,
.multiselect__input,
.multiselect__single {
    font-family: inherit;
    font-size: 16px;
    touch-action: manipulation;
}

.multiselect {
    box-sizing: content-box;
    display: block;
    position: relative;
    width: 100%;
    min-height: 40px;
    text-align: left;
    color: #35495e;
}

.multiselect * {
    box-sizing: border-box;
}

.multiselect:focus {
    outline: none;
}

.multiselect--disabled {
    background: #ededed;
    pointer-events: none;
    opacity: 0.6;
}

.multiselect--active {
    z-index: 50;
}

.multiselect--active:not(.multiselect--above) .multiselect__current,
.multiselect--active:not(.multiselect--above) .multiselect__input,
.multiselect--active:not(.multiselect--above) .multiselect__tags {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

.multiselect--active .multiselect__select {
    transform: rotateZ(180deg);
}

.multiselect--above.multiselect--active .multiselect__current,
.multiselect--above.multiselect--active .multiselect__input,
.multiselect--above.multiselect--active .multiselect__tags {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}

.multiselect__input,
.multiselect__single {
    position: relative;
    display: inline-block;
    min-height: 20px;
    line-height: 20px;
    border: none;
    border-radius: 5px;
    background: #fff;
    padding: 0 0 0 5px;
    width: calc(100%);
    transition: border 0.1s ease;
    box-sizing: border-box;
    margin-bottom: 8px;
    vertical-align: top;
}

.multiselect__input::placeholder {
    color: #35495e;
}

.multiselect__tag ~ .multiselect__input,
.multiselect__tag ~ .multiselect__single {
    width: auto;
}

.multiselect__input:hover,
.multiselect__single:hover {
    border-color: #cfcfcf;
}

.multiselect__input:focus,
.multiselect__single:focus {
    border-color: #a8a8a8;
    outline: none;
}

.multiselect__single {
    padding-left: 5px;
    margin-bottom: 8px;
}

.multiselect__tags-wrap {
    display: inline;
}

.multiselect__tags {
    min-height: 40px;
    display: block;
    padding: 5px 40px 0 0px;
    border-radius: 5px;
    background: #fff;
    font-size: 14px;
}

.multiselect__tag {
    position: relative;
    display: inline-block;
    padding: 4px 26px 4px 10px;
    border-radius: 5px;
    margin-right: 10px;
    color: #fff;
    line-height: 1;
    background: #3c8db9;
    margin-bottom: 5px;
    white-space: pre-wrap;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
}

.multiselect__tag-icon {
    cursor: pointer;
    margin-left: 7px;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    font-weight: 700;
    font-style: initial;
    width: 22px;
    text-align: center;
    line-height: 22px;
    transition: all 0.2s ease;
    border-radius: 5px;
}

.multiselect__tag-icon:after {
    content: '×';
    color: #266d4d;
    font-size: 14px;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
    background: #369a6e;
}

.multiselect__tag-icon:focus:after,
.multiselect__tag-icon:hover:after {
    color: white;
}

.multiselect__current {
    line-height: 16px;
    min-height: 40px;
    box-sizing: border-box;
    display: block;
    overflow: hidden;
    padding: 8px 12px 0;
    padding-right: 30px;
    white-space: pre-wrap;
    margin: 0;
    text-decoration: none;
    border-radius: 5px;
    border: 1px solid #e8e8e8;
    cursor: pointer;
}

.multiselect__select {
    line-height: 16px;
    display: block;
    position: absolute;
    box-sizing: border-box;
    width: 40px;
    height: 38px;
    right: 1px;
    top: 1px;
    padding: 4px 8px;
    margin: 0;
    text-decoration: none;
    text-align: center;
    cursor: pointer;
    transition: transform 0.2s ease;
}

.multiselect__select:before {
    position: relative;
    right: 0;
    top: 65%;
    color: #999;
    margin-top: 4px;
    border-style: solid;
    border-width: 5px 5px 0 5px;
    border-color: #999999 transparent transparent transparent;
    content: '';
}

.multiselect__placeholder {
    color: #adadad;
    display: inline-block;
    margin-bottom: 10px;
    padding-top: 2px;
}

.multiselect--active .multiselect__placeholder {
    display: none;
}

.multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #fff;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid #e8e8e8;
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 50000;
    -webkit-overflow-scrolling: touch;
}

.multiselect__content {
    list-style: none;
    display: inline-block;
    padding: 0;
    margin: 0;
    min-width: 100%;
    vertical-align: top;
}

.multiselect--above .multiselect__content-wrapper {
    bottom: 100%;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom: none;
    border-top: 1px solid #e8e8e8;
}

.multiselect__element {
    display: block;
}

.multiselect__option {
    display: block;
    padding: 12px;
    min-height: 40px;
    line-height: 16px;
    text-decoration: none;
    text-transform: none;
    vertical-align: middle;
    position: relative;
    cursor: pointer;
    white-space: nowrap;
}

.multiselect__option:after {
    top: 0;
    right: 0;
    position: absolute;
    line-height: 40px;
    padding-right: 12px;
    padding-left: 20px;
    font-size: 13px;
}

.multiselect__option--highlight {
    background: #3c8db9;
    outline: none;
    color: white;
}

.multiselect__option--highlight:after {
    content: attr(data-select);
    background: #3c8db9;
    color: white;
}

.multiselect__option--selected {
    background: #f3f3f3;
    color: #35495e;
    font-weight: bold;
}

.multiselect__option--selected:after {
    content: attr(data-selected);
    color: silver;
}

.multiselect__option--selected.multiselect__option--highlight {
    background: #ff6a6a;
    color: #fff;
}

.multiselect__option--selected.multiselect__option--highlight:after {
    background: #ff6a6a;
    content: attr(data-deselect);
    color: #fff;
}

.multiselect--disabled .multiselect__current,
.multiselect--disabled .multiselect__select {
    background: #ededed;
    color: #a6a6a6;
}

.multiselect__option--disabled {
    background: #ededed !important;
    color: #a6a6a6 !important;
    cursor: text;
    pointer-events: none;
}

.multiselect__option--group {
    background: #ededed;
    color: #35495e;
}

.multiselect__option--group.multiselect__option--highlight {
    background: #35495e;
    color: #fff;
}

.multiselect__option--group.multiselect__option--highlight:after {
    background: #35495e;
}

.multiselect__option--disabled.multiselect__option--highlight {
    background: #dedede;
}

.multiselect__option--group-selected.multiselect__option--highlight {
    background: #ff6a6a;
    color: #fff;
}

.multiselect__option--group-selected.multiselect__option--highlight:after {
    background: #ff6a6a;
    content: attr(data-deselect);
    color: #fff;
}

.multiselect-enter-active,
.multiselect-leave-active {
    transition: all 0.15s ease;
}

.multiselect-enter,
.multiselect-leave-active {
    opacity: 0;
}

.multiselect__strong {
    margin-bottom: 8px;
    line-height: 20px;
    display: inline-block;
    vertical-align: top;
}

*[dir='rtl'] .multiselect {
    text-align: right;
}

*[dir='rtl'] .multiselect__select {
    right: auto;
    left: 1px;
}

*[dir='rtl'] .multiselect__tags {
    padding: 8px 8px 0px 40px;
}

*[dir='rtl'] .multiselect__content {
    text-align: right;
}

*[dir='rtl'] .multiselect__option:after {
    right: auto;
    left: 0;
}

*[dir='rtl'] .multiselect__clear {
    right: auto;
    left: 12px;
}

*[dir='rtl'] .multiselect__spinner {
    right: auto;
    left: 1px;
}

@keyframes spinning {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(2turn);
    }
}

td.color-focus {
    background-color: #39aff3 !important;
    font-weight: 500;
}

td.color-focus:hover {
    background: #7dcaf7 !important;
}

.total-curve {
    background: var(--discontinued);
    color: #fff;
}

.total-items {
    background-color: var(--inStock);
    color: #fff;
    text-align: center;
}

.total-stock {
    background: var(--notStock);
    color: #fff;
    text-align: center;
}

.top-container {
    background-color: #f1f1f1;
    text-align: center;
}

.header-search {
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 2;
    padding: 0 15px;
}

.sticky {
    position: sticky;
    top: 0;
    width: calc(100% - 110px);
    z-index: 2;
}

.search__card {
    margin-top: 10px !important;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px,
        rgba(0, 0, 0, 0.3) 0px 18px 36px -18px;
}

.label_check {
    font-size: 13px;
    font-weight: 400;
    color: #aaaaaa !important;
    line-height: 1.4;
}

@media (max-width: 900px) {
    .sticky {
        width: calc(100%);
    }
}

.header__filter {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    align-content: center;
}

.filter__aply {
    margin-left: 0.1rem;
    font-size: 1rem;
    margin-top: 1rem;
    text-decoration: underline;
    color: #ccc;
    cursor: not-allowed;
}

.card-stock {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    background: #fff;
    margin-bottom: 1rem;
    border-radius: 12px;
}

.table-header {
    border: thin solid rgba(0, 0, 0, 0.12);
    background-color: var(--gray-200);
    text-transform: uppercase;
    font-weight: 600;
}
</style>
